import { formatEther, formatUnits, parseEther, parseUnits } from 'ethers/lib/utils';
import { AddMarginToPositionParamsStruct } from '../../config/contracts/typechain/ITradeManager';

const generateDepositPositionLog = (
    margin: string,
    volume: string,
    decimals: number,
    params: AddMarginToPositionParamsStruct
) => {
    const newMargin = formatUnits(
        parseUnits(margin, decimals).add(params.addedMargin.toString()),
        decimals
    );

    const newLeverage = formatEther(
        parseEther(volume).mul(parseEther('1')).div(parseEther(newMargin))
    );

    return { newMargin, newLeverage };
};

export default generateDepositPositionLog;
